export default function Hero() {
  const handleCallNow = () => {
    window.location.href = 'tel:9412233052';
  };

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/03570925b581cd873ee9f67cb0c788a4.jpg"
          alt="Florida Home"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Navigation */}
      <nav className="absolute top-0 left-0 right-0 z-20 px-6 py-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/2626c5dd14f7e79bab7b94489c13c72e/3f647aacc53a85cf6a7976138ca68ef4.png" 
              alt="Doolittle Air - Heating & Cooling" 
              className="h-20 w-auto drop-shadow-lg"
            />
          </div>
          <div className="flex items-center gap-8">
            <a href="tel:9412233052" className="text-white text-xl font-semibold hover:text-orange-400 transition-colors whitespace-nowrap">
              <i className="ri-phone-fill mr-2"></i>
              (941) 223-3052
            </a>
          </div>
        </div>
      </nav>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <p className="text-orange-400 text-xl font-semibold uppercase tracking-widest mb-3">
          Welcome to
        </p>
        <h1 className="text-6xl md:text-8xl font-extrabold text-white mb-4 tracking-wide drop-shadow-lg">
          DOOLITTLE AIR
        </h1>
        <p className="text-2xl md:text-3xl font-semibold text-orange-400 mb-4 tracking-wide">
          SARASOTA'S TRUSTED HVAC EXPERTS SINCE 2006
        </p>
        
        <p className="text-xl text-white mb-12 font-light">
          Same Day Service • Licensed &amp; Insured • Honest Pricing
        </p>

        <div className="mb-10">
          <a 
            href="tel:9412233052" 
            className="inline-block text-5xl md:text-6xl font-bold text-orange-500 hover:text-orange-400 transition-colors"
          >
            (941) 223-3052
          </a>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <button
            onClick={handleCallNow}
            className="px-10 py-5 bg-orange-500 text-white text-xl font-semibold rounded-full hover:bg-orange-600 transition-all shadow-lg hover:shadow-xl flex items-center gap-3 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-2xl"></i>
            CALL NOW FOR SERVICE
          </button>
          <button
            onClick={scrollToContact}
            className="px-10 py-5 bg-transparent border-3 border-white text-white text-xl font-semibold rounded-full hover:bg-white hover:text-orange-500 transition-all flex items-center gap-3 whitespace-nowrap cursor-pointer"
          >
            REQUEST ESTIMATE
            <i className="ri-arrow-right-line text-2xl"></i>
          </button>
        </div>

        <div className="flex items-center justify-center gap-6 text-white text-lg">
          <span className="flex items-center gap-2">
            <i className="ri-home-heart-fill text-orange-500"></i>
            Family Owned
          </span>
          <span className="text-orange-500">•</span>
          <span className="flex items-center gap-2">
            <i className="ri-star-fill text-orange-500"></i>
            18+ Years Experience
          </span>
          <span className="text-orange-500">•</span>
          <span className="flex items-center gap-2">
            <i className="ri-star-fill text-orange-500"></i>
            5-Star Rated
          </span>
        </div>
      </div>
    </section>
  );
}